import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

// api
import peopleApi from '../../../../../src/apis/peopleApi';

// helpers
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';

// reusable
import SocialTab from '../SocialTab';
import { renderLockedGeneralSection } from '/src/components/LockedContent';
import Pagination from '/src/components/Pagination/Pagination';

// constants
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';

const amplitudeHelper = new AmplitudeHelperClass();
const LIMIT = 5;

const PeopleSection = (props) => {

    const [state, setState] = useState({
        peopleData: [],
        isLoading: false,
        page: 1,
        limit: LIMIT,
        limitOptions: [5, 10, 20],
        totalDBData: 0,
        focusedEntityId: null
    });

    const { peopleData, isLoading, page, limit, limitOptions, totalDBData, focusedEntityId } = state;
    const { user, isDirSlider, entityType, entityId, entityName } = props;
    const hasAccess = (user && user?.is_loggedin && (user?.roles.includes(MAGNITT_ACCESS_ROLES.directory_access)
		|| user?.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access)));

    const hasPeopleData = (peopleData && peopleData.length > 0);

    const updateState = (newState) => {
        setState((prevState) => ({ ...prevState, ...newState }));
    };

    useEffect(() => {
        if (user.is_loggedin && hasAccess) {
            updateState({ focusedEntityId: entityId });
            loadData()
        }
    }, []);

    useEffect(() => {
        if (focusedEntityId !== entityId) {
            updateState({ focusedEntityId: entityId, peopleData: [], totalDBData: null });
            loadData();
        }
    }, [entityId]);

    const loadData = () => {
        const { page: currentPage, limit: currentLimit } = state;

        updateState({ isLoading: true });

        peopleApi.getPeopleTeamData(entityId, entityType, currentPage, currentLimit).then(

            response => {
                const tempResponse = [...response.data]

                // prepare team item
                const sortedData = tempResponse.sort((a, b) => {
                    a.emailViewed = false;
                    b.emailViewed = false;
                    return b.is_founder - a.is_founder
                });

                updateState({
                    peopleData: sortedData,
                    totalDBData: response.navigation.total,
                    isLoading: false
                });
            }
        ).catch(() => {
            updateState({
                isLoading: false
            });
        });
    };

    const amplitudeTrack = (action) => {
        amplitudeHelper.trackEvent(action);
    };

    const renderTeamMember = (data, index) => {
        const {
            people_data,
            team_role_data,
            is_founder
        } = data;

        if (!isEmpty(people_data)) {
            const name = `${people_data.first_name} ${people_data.last_name}`;
            const teamrole = team_role_data ? team_role_data.name : 'N/A';

            let emailValue = '';
            const hasEmail = people_data && people_data.email;
            if (hasEmail) {
                emailValue = people_data.email.toLowerCase();
            }

            const social_media_links = {
                facebook: people_data?.facebook,
                linkedin: people_data?.linkedin,
                skype: people_data?.skype,
                twitter: people_data?.twitter,
                email: emailValue,
            };
            const hasContact = Object.values(social_media_links).some((value) => !!value);

            const amplitudeTrackSocial = (trackData) => {
                amplitudeHelper.trackEvent('Team contact link clicked', {
                    entity_type: entityType,
                    entity_id: entityId,
                    ...trackData
                });
            };

            return (
                <tr key={`team-${people_data?.id || index}`}>
                    <td data-title="Name" className="entity-row">
                        <div className="entity-row-box">
                            <p>{name}</p>
                        </div>
                    </td>

                    <td data-title="Role">
                        {teamrole} {is_founder == true && entityType === 'startup' && <span className="badge badge-pill founder-badge">Founder</span>}
                    </td>

                    <td className="contact-column" data-title="Contact">
                        {hasContact ?
                            <SocialTab
                                object={social_media_links}
                                size={"small"}
                                amplitudeTrack={(trackData) => amplitudeTrackSocial(trackData)}
                            />
                            :
                            <span className="no-contact-value">N/A</span>
                        }
                    </td>
                </tr>
            );
        }

        return null;
    };

    const renderTeamTableHeader = () => {
        return (
            <tr className="table-header-desktop exits-table-header">
                <th>Name</th>
                <th>Role</th>
                <th>Contact</th>
            </tr>
        )
    }

    const renderTeamTableData = () => {
        if (!hasPeopleData || !user.is_loggedin) {
            return [];
        }

        return state.peopleData.map((data, index) => renderTeamMember(data, index));
    }

    const renderPeopleContent = () => {
        const teamContent = renderTeamTableData();
        const teamCountText =
			<span className="count-text">
				({entityName} has <span className="count-span-text"><strong>{totalDBData}</strong></span> team members)
			</span>

        if (!hasPeopleData) {
            return null;
        } else if (user.is_loggedin && hasAccess) {
            return (
                <>
                    {isDirSlider && <hr />}
                    <div className="block team team-section team-members-section">
                        <div className="title d-flex">
                            <h2>Team Members</h2>
                            <span style={{ marginLeft: 5, color: '#adb1b5', fontSize: 15 }}>
                                {teamCountText}
                            </span>
                        </div>

                        <div className="mt-0 table-container" id="no-more-tables" style={{ width: '100%' }} >
                            <table className="w-100 people-section-table">
                                <tbody>
                                    {renderTeamTableHeader()}
                                    {teamContent}
                                </tbody>
                            </table>
                        </div>

                        <div className="funding-table-pagination" data-table-type="teams">
                            <Pagination
                                page={page}
                                totalRecords={totalDBData}
                                limit={limit}
                                limitOptions={limitOptions}
                                setParentState={updateState}
                                fetchData={loadData}
                                isLoading={isLoading}
                                tableName="section-teams"
                            />
                        </div>
                    </div>
                </>
            );
        } else {
            const dataType = "employees";
            return (renderLockedGeneralSection(entityType, dataType, false, props.setState, 'Team Members'));
        }
    }

    return renderPeopleContent()
}

export default PeopleSection;

